import { render, staticRenderFns } from "./eventsList.vue?vue&type=template&id=78b9b5ca"
import script from "./eventsList.vue?vue&type=script&lang=js"
export * from "./eventsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports